

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AutoCommDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface AutoCommDetails {
    id?: number;
    sentThrough: string;
    message:string;
    
  parameters?: AutoCommDetailsParameter[];
  links?: any;
}

export abstract class AutoCommDetailsData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AutoCommDetails[]>;
  abstract create(url: string,data: AutoCommDetails): Observable<any>;
  abstract update(url: string,data: AutoCommDetails): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
